import * as React from "react"
import Svg, { Path } from "react-native-svg"

function BackArrowSvg(props) {
  return (
    <Svg
      width={10}
      height={17}
      viewBox="0 0 10 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M8 15.5L2 8.75 8 2"
        stroke="#333"
        strokeWidth={2.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export default BackArrowSvg
